module.exports = __webpack_public_path__ + "img/table-icon-instagram-disabled.67a1218f.png";